import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const circle: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11.188-8.016Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.002 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};

export const circleOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8.125-8.672A4.1 4.1 0 0 0 6-9.25a4.17 4.17 0 0 0-2.14.578 4.2 4.2 0 0 0-1.547 1.547A4.17 4.17 0 0 0 1.75-5q0 1.158.563 2.14a4.3 4.3 0 0 0 1.546 1.548A4.23 4.23 0 0 0 6-.75q1.154 0 2.125-.562A4.2 4.2 0 0 0 9.672-2.86 4.17 4.17 0 0 0 10.25-5q-.002-1.154-.578-2.125a4.1 4.1 0 0 0-1.547-1.547m3.063.656Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.002 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};

export const circleOutlineNotched: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13.75-5a6.7 6.7 0 0 1-.531 2.625A6.8 6.8 0 0 1 11.78-.219 6.84 6.84 0 0 1 7 1.75a6.7 6.7 0 0 1-2.625-.531A6.8 6.8 0 0 1 2.219-.22 7 7 0 0 1 .78-2.375 6.6 6.6 0 0 1 .25-5q0-1.668.75-3.11a6.75 6.75 0 0 1 2.078-2.39A6.75 6.75 0 0 1 6-11.687v1.78a4.94 4.94 0 0 0-2.86 1.735A4.82 4.82 0 0 0 2-5q0 1.018.39 1.938A5.08 5.08 0 0 0 5.064-.391Q5.98.001 7 0q1.013 0 1.938-.39a4.975 4.975 0 0 0 2.656-2.672A4.8 4.8 0 0 0 12-5a4.85 4.85 0 0 0-1.14-3.172A4.9 4.9 0 0 0 8-9.906v-1.781a6.8 6.8 0 0 1 2.922 1.187 6.6 6.6 0 0 1 2.062 2.39c.508.962.766 1.997.766 3.11m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.25 11.687)"
    />
  ),
  svgProps: {
    height: "13.438",
    width: "13.5",
  }
};

export const circleThin: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7.938-9.594A4.8 4.8 0 0 0 6-10a4.8 4.8 0 0 0-1.937.406 4.975 4.975 0 0 0-1.594 8.125q.667.675 1.594 1.078Q4.98.001 6 0q1.012 0 1.938-.39a4.975 4.975 0 0 0 2.656-2.672A4.8 4.8 0 0 0 11-5q-.001-1.013-.406-1.937A4.8 4.8 0 0 0 9.53-8.531a4.8 4.8 0 0 0-1.593-1.063m3.25 1.578Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.002 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};